<app-barra-consulta-mensal *ngIf="!carregando" visible="false" (inserindo)="novo($event)"
  (definirFiltro)="definirFiltragem()" [exibirNovo]="false" (voltando)="voltar()" [exibirBotaoDefinirFiltros]="false"
  [exibirBotaoBuscar]="false">
</app-barra-consulta-mensal>

<div class="conteudo ml-2 mr-2">
  
  <app-curva-abc-lista (exibir)="selecionar($event)" [carregar]="filtrar()">
  </app-curva-abc-lista>
  <!-- <app-selecionar [idModal]="'modal-dealers'" [titulo]="modalTexto" [lista]="filtroDealers.naoSelecionados()"
    (escolhido)="onAdicionarDealerFiltro($event)">
  </app-selecionar> -->
</div>